import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';

@Component({
    selector: 'app-wrapper',
    templateUrl: './wrapper.component.html',
    styleUrls: ['./wrapper.component.css']
})
export class WrapperComponent implements OnInit {

    constructor(private router: Router) {

    }

    ngOnInit() {
        if (this.router.url.indexOf('login') !== -1) {
            this.router.navigate(['/']);
        }
    }

}
